import { LocationModalPermissions } from '../../../../global/constants/permissions'
import isRoleFound from '../../../../global/helper-functions/is-role-found'

function determineIfUserCanEdit(
  isReadOnlyMap: LocationModalPermissions,
  userRole: string,
) {
  return !(
    isRoleFound(isReadOnlyMap.blockedOffTimes, userRole) &&
    isRoleFound(isReadOnlyMap.installerId, userRole) &&
    isRoleFound(isReadOnlyMap.locationInfo, userRole) &&
    isRoleFound(isReadOnlyMap.spokeLocations, userRole) &&
    isRoleFound(isReadOnlyMap.tabulationAreas, userRole) &&
    isRoleFound(isReadOnlyMap.technicianEmails, userRole) &&
    isRoleFound(isReadOnlyMap.tireLocations, userRole) &&
    isRoleFound(isReadOnlyMap.websiteScheduleBuffer, userRole) &&
    isRoleFound(isReadOnlyMap.workingDays, userRole)
  )
}

export default determineIfUserCanEdit
